import React from 'react';
import {
  WidgetKeys,
} from 'mobx-store/stores/customScreens/types';
import GeneralWidget from './GeneralWidget';
import {
  WidgetBaseProps,
} from './types';
import HorizontalWidget from './HorizontalWidget';
import VerticalWidget from './VerticalWidget';
import ImageWidget from './ImageWidget';
import IconWidget from './IconWidget';
import ThumbnailWidget from './ThumbnailWidget';
import ClubOccupancyWidget from './clubOccupancyWidget';
import SliderWidget from './SliderWidget';
import TabWidget from './TabWidget';
import TitleWidget from './TitleWidget';
import AccountControlWidget from './AccountControlWidget';
import HeaderInfoWidget from './HeaderInfoWidget';
import PointsWidget from './PointWidget';
import DescriptionWidget from './DescriptionWidget';
import NoPointsWidget from './NoPointWidget';
import HomePointsWidget from './HomePointsWidget';
import CardsReceivalWidget from './cardsReceivalWidget';

const Widget: React.FC<WidgetBaseProps> = (props: WidgetBaseProps) => {
  const {
    widget,
    defaultPaddings,
  } = props;
  return (
    <>
      {
        widget.widgetKey === WidgetKeys.GENERAL_WIDGET
        && (
          <GeneralWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.HORIZONTAL_WIDGET
        && (
          <HorizontalWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.VERTICAL_WIDGET
        && (
          <VerticalWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.IMAGE_WIDGET
        && (
          <ImageWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.ICON_WIDGET
        && (
          <IconWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.CLUB_OCCUPANCY_WIDGET
        && (
          <ClubOccupancyWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.SLIDER_WIDGET
        && (
          <SliderWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.THUMBNAIL_WIDGET
        && (
          <ThumbnailWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.TAB_WIDGET
        && (
          <TabWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.TITLE_WIDGET
        && (
          <TitleWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.HEADER_INFO_WIDGET
        && (
          <HeaderInfoWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.ACCOUNT_CONTROL_WIDGET
        && (
          <AccountControlWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.POINTS_WIDGET
        && (
          <PointsWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.DESCRIPTION_WIDGET
        && (
          <DescriptionWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.NO_POINTS_WIDGET
        && (
          <NoPointsWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
      {
        widget.widgetKey === WidgetKeys.HOME_POINTS_WIDGET
        && (
          <HomePointsWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }

      {
        widget.widgetKey === WidgetKeys.CARD_RECEIVAL_WIDGET
        && (
          <CardsReceivalWidget
            widgetParams={widget.params}
            defaultPaddings={defaultPaddings}
          />
        )
      }
    </>
  );
};

export default Widget;
